import React from 'react';
import { Flex, Text } from '@chakra-ui/layout';
import { CustomIcon } from 'components';

interface IProps {
  href: string;
  onClick: (e: any) => any;
  hidden: boolean;
  label: string;
  iconName: any;
  noSphere?: boolean;
  aIconName?: any;
  isActivated?: boolean;
}

const Link: React.FC<IProps> = ({
  href,
  onClick,
  hidden,
  label,
  iconName,
  noSphere,
  aIconName,
  isActivated,
}) => {
  return (
    <Flex
      w="176px"
      h="44px"
      bg={isActivated ? 'brand.primary' : 'transparent'}
      color={isActivated ? 'brand.1300' : 'brand.gray600'}
      borderRadius="4px"
      mb="16px"
      as="a"
      href={href}
      onClick={onClick}
      alignItems="center"
      pl="19px"
      transition="all ease-in 200ms"
      _hover={{
        opacity: 0.86,
        backgroundColor: 'brand.primary',
        color: 'brand.1300',
      }}
      hidden={hidden}
      _active={{
        opacity: 0.6,
      }}
      display={label === 'Portal Daniel' || label === 'Clientes' ? 'none' : 'flex'}
    >
      <CustomIcon
        $noSphere={noSphere}
        position="top-left"
        size="18px"
        icon={(isActivated && aIconName) || iconName}
      />
      <Text ml="5" fontSize="14px">
        {label}
      </Text>
    </Flex>
  );
};

export default Link;
